module.exports = require("core-js/library/fn/object/assign");


//////////////////
// WEBPACK FOOTER
// external "core-js/library/fn/object/assign"
// module id = 8
// module chunks = 0